import People from '@material-ui/icons/People';

import List from './List3';

export default {
  list: List,
  icon: People,
};
